export const COMPS_VIEW_VALUES = ['TILE_VIEW', 'LIST_VIEW', 'TABLE_VIEW'] as const

export type CompsView = typeof COMPS_VIEW_VALUES[number]

export const DEFAULT_COMPS_VIEW: CompsView = 'TILE_VIEW'
